<app-header></app-header>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
